import React from 'react';
import './rulesOne.css'

export default function RulesOne({history}) {

    function goToQuestions(){
        history.push('/questions')
    }

    return (
        <div>
            <p className='title-page'>Regras</p>
            <p className='text'>
            Classifique cada sentença conforme descreva mais precisamente seu comportamento e pensamento, de acordo com os números a seguir:
                </p>
            <p className='topic'> 01. Nunca </p>
            <p className='topic'> 02. Raramente </p>
            <p className='topic'> 03. Em parte </p>
            <p className='topic'> 04. Geralmente </p>
            <p className='topic'> 05. Sempre </p>
            
            <button className="continue-btn" onClick={goToQuestions}>Continuar</button>
        </div >
    );
}